import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import emailjs from "emailjs-com";
import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import SimpleMap from "../components/SimpleMap"; // vagy LeafletMap

const TITLE = Config.SITE_TITLE + " | Kapcsolat";
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const ContactHu = () => {
  const form = useRef();
  const navigate = useNavigate();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, // Az EmailJS szolgáltatás ID a .env fájlból
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // Az EmailJS sablon ID a .env fájlból
        form.current,
        process.env.REACT_APP_EMAILJS_USER_ID // A felhasználói azonosító a .env fájlból
      )
      .then(
        (result) => {
          console.log(result.text);
          navigate("/hu/koszonjuk");
        },
        (error) => {
          console.log(error.text);
          alert("Hiba történt az üzenet küldésekor.");
        }
      );
  };

  return (
    <main className="contact-main-content">
      <Helmet>
        <title>Kapcsolat | Csillag Masszázs Pedikűr</title>
        <meta
          name="description"
          content="Keressen minket időpontfoglalással kapcsolatban! Budapesten a III. kerületben, szalonban vagy háznál is elérhetőek vagyunk."
        />
        <link rel="canonical" href="https://janoseszter.com/hu/Contact" />

        <meta
          property="og:title"
          content="Kapcsolat | Csillag Masszázs Pedikűr"
        />
        <meta
          property="og:description"
          content="Vegye fel velünk a kapcsolatot! Masszázs és pedikűr időpontok Budapesten. Telefon, email, térkép."
        />
        <meta property="og:url" content="https://janoseszter.com/hu/Contact" />
        <meta
          property="og:image"
          content="https://janoseszter.com/images/logo225.png"
        />
        <meta property="og:site_name" content="janoseszter.com" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "HealthAndBeautyBusiness",
              "name": "Csillag Masszázs Pedikűr",
              "image": "https://janoseszter.com/images/logo225.png",
              "url": "https://janoseszter.com",
              "telephone": "+36 70 554 1606",
              "priceRange": "Ft",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Éden utca 8.",
                "addressLocality": "Budapest",
                "postalCode": "1038",
                "addressCountry": "HU"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 47.5923,
                "longitude": 19.0555
              },
              "openingHoursSpecification": [
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Saturday", "Sunday"],
                  "opens": "10:00",
                  "closes": "18:00"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday"
                  ],
                  "opens": "18:00",
                  "closes": "21:00"
                }
              ],
              "sameAs": [
                "https://www.facebook.com/profile.php?id=61551742774521"
              ]
            }
        `}
        </script>
      </Helmet>
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact pt-4 ps-3">Kapcsolat</h1>
        </div>

        <div className="contact-content-container w-75">
          <h1>A Szolgáltatási helyeim</h1>

          <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
            <SimpleMap />
          </div>

          {/* Nyitvatartás + cím */}
          <div className="mb-4">
            <h2>Nyitvatartás</h2>
            <h3>Delice Éden Szépségszalon</h3>
            <p>
              <strong>Szombat:</strong> 10:00 – 18:00
            </p>
            <p>
              <strong>Vasárnap:</strong> 10:00 – 18:00
            </p>
            <h3>Az Ön otthona kényelmében</h3>
            <p>
              <strong>Hétfő – Péntek:</strong> 18:00 – 21:00
            </p>
            <h4 className="contact-margin-y1">
              Lépjen kapcsolatba velünk, kérjen időpontot masszázsra vagy
              pedikűrre.
            </h4>
            <h2 className="mt-4">Elérhetőség</h2>
            <p>
              <strong>Cím:</strong> <strong>Delice Éden Szalon:</strong> 1038
              Budapest, Éden utca 8.
            </p>
            <p>
              <strong>Cím:</strong> <strong>Az Ön otthonában</strong> 3200
              Gyöngyös, Rédei út 5.
            </p>
            <p>
              <strong>Telefon:</strong>{" "}
              <a href="tel:+36705541606">+36 70 554 1606</a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@janoseszter.com?subject=Kérdés%20a%20szolgáltatásokkal%20kapcsolatban&body=Kedves%20Eszter,%0D%0A%0D%0AÉrdeklődöm%20a%20szolgáltatások%20iránt.%20Szeretnék%20több%20információt%20kapni%20a%20következő%20témában:%0D%0A%0D%0A[Írd%20be%20ide%20a%20kérdéseidet%20vagy%20megjegyzéseidet]%0D%0A%0D%0AÜdvüzlettel,%0D%0AJános%20Eszter"
                target="_top"
              >
                info@janoseszter.com
              </a>
            </p>
            <p>
              Facebook:{" "}
              <a
                href="https://www.facebook.com/profile.php?id=61551742774521"
                target="blank"
              >
                Csillag masszázs pedikűr
              </a>
            </p>
            {/* Gombok */}
            <div className="mt-3 d-flex gap-3">
              <a href="tel:+36201234567" className="btn btn-success">
                📞 Hívás
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=1038+Budapest,+Éden+utca+8"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                🗺️ Útvonaltervezés
              </a>
            </div>
          </div>

          {/* Form that sends email */}
          <form
            ref={form}
            onSubmit={sendEmail}
            className="contact-margin-y contact-color"
          >
            <h2>
              <b>Vagy küldjön nekünk üzenetet az alábbi űrlapon keresztül</b>
            </h2>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputVezNev" className="form-label">
                Vezetéknév <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="vezeteknev"
                placeholder="Vezetéknév"
                required
              />
            </div>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputKeresztNev" className="form-label">
                Keresztnév <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="keresztnev"
                placeholder="Keresztnév"
                required
              />
            </div>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputEmail1" className="form-label">
                Email cím: <span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="E-mail cím"
                required
              />
              <div id="emailHelp" className="form-text">
                Soha nem osztjuk meg e-mail-címét másokkal.
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="comment">
                Üzenet: <span>*</span>
              </label>
              <textarea
                className="form-control"
                rows="5"
                name="comment"
                required
              ></textarea>
            </div>
            <div className="mt-4 mb-4 form-check">
              <h6>
                A Mentés gomb megnyomásával elismerem, hogy elolvastam,
                megértettem és elfogadom az Adatvédelmi Tájékoztatót, mely
                alapján az oldal az adataimat kezeli.
              </h6>
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
                required
              />
              <label className="form-check-label" htmlFor="exampleCheck1">
                Hozzájárulok ahhoz, hogy a megadott személyes adataimat a
                Csillag Masszázs Pedikűr - hozzájárulásom visszavonásáig -
                közvetlen üzletszerzési célra (tájékoztatás, közvélemény- vagy
                piackutatás, illetve egyéb tájékoztatás) felhasználja.
              </label>
            </div>
            <button type="submit" className="btn btn-outline-primary">
              Küldés
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default ContactHu;
